<div class="timeline-wrapper" [class.loading]="loading">
  <div class="timeline-header mb-6">
    <div class="label-wrapper">
      <div class="title title-lg">
        {{
          isNormalizedDataFetched
            ? ('signals-ng-visualization-tab.timeline.interestOverTime' | translate)
            : ('signals-ng-visualization-tab.timeline.signalsOverTime' | translate)
        }}
      </div>
      <span
        [ui2Tooltip]="
          isNormalizedDataFetched
            ? ('signals-ng-visualization-tab.timeline.interestOverTimeTooltip' | translate)
            : ('signals-ng-visualization-tab.timeline.signalsOverTimeTooltip' | translate)
        "
        [mode]="ToolTipMode"
      >
        <span class="icon2-x16-info"></span>
      </span>
    </div>

    <ui-menu-container
      *ngIf="isDropDownMenuEnabled"
      [applyClass]="className"
      [trigger]="trigger"
      [placement]="placement"
      (onShow)="popperOnShown()"
      (onHidden)="popperOnHidden()"
    >
      <ng-template #buttonTemplate>
        <span class="icon" [ngClass]="{ 'icon2-x16-options': !showingConfig, 'icon2-x16-close-m': showingConfig }"> </span>
      </ng-template>

      <div class="config-wrapper">
        <div class="filter-by-date">
          <div class="label-sm filter-date-label">{{ 'signals-ng-visualization-tab.configPanel.datesRange' | translate | titleCase }}</div>
          <signals-filter-date
            class="filter-date"
            [datePickerAlignment]="datePickerAlignment"
            [title]="range && range.length ? (range[0] | date: 'mediumDate') + ' - ' + (range[1] | date: 'mediumDate') : ''"
            [globalFilter]="documentsFilter"
          ></signals-filter-date>
        </div>
        <!-- Group by -->
        <div class="group-by-dropdown">
          <div uiHotspot="timelineGroupBy">
            <signals-group-by-dropdown [list]="properties" (changed)="propertyChanged($event)"></signals-group-by-dropdown>
          </div>
        </div>

        <div class="normalize-series">
          <div uiHotspot="timelineNormalizeBy">
            <signals-normalize-series (changes)="normalize($event)"></signals-normalize-series>
          </div>
        </div>
      </div>
    </ui-menu-container>

    <!-- Key events toggle switch -->
    <div *ngIf="isKeyEventsFeatureFlagEnabled" class="key-events-toggle-switch">
      <!-- switch -->
      <span
        [maxWidth]="keyEventsTooltipWidth"
        [ui2Tooltip]="isKeyEventsSwitchDisabled && ('signals-ng-visualization-tab.timeline.noKeyEvents' | translate)"
      >
        <div class="switch">
          <span class="label label-sm-semibold-single mr-3" [class.disabled]="isKeyEventsSwitchDisabled || isNormalizeProcessStillRunning">
            {{ 'signals-ng-visualization-tab.timeline.showKeyEvents' | translate }}</span
          >
          <ui2-toggle-switch
            [class.disabled]="isKeyEventsSwitchDisabled || loading || isNormalizeProcessStillRunning"
            [(ngModel)]="isKeyEventsToggleEnabled"
            (ngModelChange)="onKeyEventsSwitchStateChange($event)"
          ></ui2-toggle-switch>
        </div>
      </span>
    </div>
  </div>

  <div uiHotspot="timlineVisualization">
    <chart-timeline
      class="chart-timeline mb-6"
      [(rangeSelectModel)]="dateRangeSelectModel"
      (rangeSelectModelChange)="select($event)"
      (trackEvent)="trackEvent($event)"
      [step]="stepType"
      [range]="range"
      [keyEventsData]="keyEventsData"
      [keyEventPathData]="keyEventsDurationPathData"
      [data]="dataFiltered"
      [noData]="noData"
      [normalizedDataRange]="isNormalizedDataFeatureFlagEnabled ? normalizedDataRange : null"
      [categoryKey]="property.type"
      [showYAxis]="!isNormalizedDataFeatureFlagEnabled"
      [showLegend]="!isNormalizedDataFeatureFlagEnabled"
      [seriesLimitMessage]="seriesLimitMessage"
      (keyEventSelected)="selectKeyEvent($event)"
      [selectKeyEvent]="selectedKeyEvent"
      [loading]="loading"
      [isNormalizeProcessStillRunning]="isNormalizeProcessStillRunning"
      [isOldElement]="isOldElement"
      [noDataTimeframe]="noDataHint"
    ></chart-timeline>

    <!-- Code commented now as backend is yet to be implemented. -->
    <ng-container *ngIf="isStrongSignalsFeatureFlagEnabled">
      <div [class.visible]="isNewsType && isKeyEventsToggleEnabled" class="strong-signals">
        <signals-cluster-scrollable-list
          [entity]="entity"
          [selectedKeyEvent]="selectedKeyEvent"
          [filter]="filter"
          (onClusterClick)="onCusterClick($event)"
          [title]="'signals-ng-visualization-tab.strong-signals.topEvents' | translate"
        ></signals-cluster-scrollable-list>
      </div>
    </ng-container>
  </div>
</div>
